export default {
  name: 'g4gBlock',
  components: {},
  props: [],
  data() {
    return {
      assetsUrl: 'https://cdn.shopify.com/s/files/1/0281/7544/t/96/assets',
    };
  },
  methods: {},
};
